
var _MimeDB = require("mime-db");
var FileSaver = require("file-saver");
export class DataUrl{
    /**
     * Creates a data url object
     * @param mimeType The DataUrl's MimeType
     * @param data The data
     * @param isBase64 Whether the data is encoded as base64
     */

    private _mimeType: any;
    private _data: any;
    private _isBase64: any;
    constructor(mimeType, data, isBase64) {
        if (isBase64 === void 0) { isBase64 = false; }
        this._mimeType = mimeType;
        this._data = data;
        this._isBase64 = isBase64;
    }
    /**
     * Returns if this data url is encoded as base64. If return is null, then it is undetermined
     */
    isBase64 = function () {
        return this._isBase64;
    };
    /**
     * Get the MIME type of this data url
     */
    getMimeType = function () {
        return this._mimeType;
    };
    /**
     * Get the data of this data url
     */
    getData = function () {
        return this._data;
    };
    /**
     * Serialize this data url to a string
     */
    toString = function () {
        if (this._data === null) {
        }
        var _mime = this._mimeType ? this._mimeType.toString() : '';
        var _base64 = this._isBase64 ? ';base64' : '';
        // console.log('häh', `data:${_mime}${_base64},${this._data}`);
        return ("data:" + _mime + _base64 + "," + this._data).toString();
    };
    /**
     * Thanks to m3g4p0p @ https://www.sitepoint.com/community/t/converting-images-to-a-base64-data-url/282947/2
     * @param imageUrl A local url that leads to an image file in the system
     * @param options Optional options, see https://developer.mozilla.org/de/docs/Web/API/HTMLCanvasElement/toDataURL
     */
    static fromImageUrl = function (imageUrl, options?) {
                return new Promise<DataUrl>(function (resolve, reject) {
                        var img = new Image();
                        img.crossOrigin = 'anonymous';
                        img.src = imageUrl;
                        img.onload = function () {
                            var canvas = document.createElement('canvas');
                            canvas.width = img.width;
                            canvas.height = img.height;
                            var ctx = canvas.getContext('2d');
                            ctx.drawImage(img, 0, 0);
                            var _type = (options && options.type) ? options.type.toString() : null;
                            var _encoderOptions = (options && options.encoderOptions) ? options.encoderOptions : null;
                            var _dataUrl : DataUrl = DataUrl.fromString(canvas.toDataURL(_type, _encoderOptions));
                            // release the occupied references
                            img = null;
                            canvas = null;
                            ctx = null;
                            // this.addBase64Image(refToZip, {nameAndFullPath: _imgPath, imageAsBase64: _base64Image});
                            resolve(_dataUrl);
                        }
                        // console.log('IIIIII', img.onload)
                    });
    };
    /**
     * Checks if the given string is valid.
     * Useful for checking before creating the actual object
     * @param string The string that shall be checked
     */
     static isValidDataUrlString = function (string) {
        // use the instantion to check whether or not the string is valid
        try {
            var x = this.fromString(string);
        }
        catch (e) {
            return false;
        }
        return true;
    };
    /**
     * Get an url-safe string that can be passed via GET requests
     * @param trim If true, the fillers (=/.) will be omitted
     */
    getUrlSafeString = function (trim) {
        if (trim === void 0) { trim = false; }
        var tmp = this.toString()
            // replaces the slash (/)
            .replace(/\//gm, '-')
            // replaces the plus (+)
            .replace(/\+/gm, '_');
        // if the string is to be trimmed, omit the fillers
        // replaces the equal sign (=)
        if (trim) {
            tmp.replace(/=/gm, '');
        }
        else {
            // otherwise replace the fillers with url safe char
            tmp.replace(/=/gm, '.');
        }
        return tmp;
    };
    /**
     * Create a DataUrl object from an url-safe string
     * @param urlSafeString
     */
     static fromUrlSafeString = function (urlSafeString) {
        var decodedString = urlSafeString
            // replaces the dash (-)
            .replace(/-/gm, '/')
            // replaces the underscore (_)
            .replace(/_/gm, '+')
            // replaces the minus (-)
            .replace(/\./gm, '=');
        return this.fromString(decodedString);
    };
    /**
     * Get an url-safe string that can be passed via GET requests
     * An alias for getUrlSafeString()
     * @param trim If true, the fillers (=/.) will be omitted
     */
     static encodeUrlSafe = function (trim) {
        if (trim === void 0) { trim = false; }
        return this.getUrlSafeString(trim);
    };
    /**
     * Create a DataUrl object from an url-safe string
     * An alias for fromUrlSafeString()
     * @param urlSafeString
     */
     static decodeUrlSafe = function (urlSafeString) {
        return this.fromUrlSafeString(urlSafeString);
    };
    /**
     * Permanently removes the fillers at the end of the data section (=)
     */
    trim = function () {
        this._data.replace('=', '');
    };
    /**
     * Determines whether a given url is a valid url-safe data url
     * @param dataUrl
     */
     static isUrlSafeDataUrl = function (dataUrl) {
        try {
            this.fromUrlSafeString(dataUrl);
            return true;
        }
        catch (_a) {
            return false;
        }
    };
    /**
     * Creates a data url object from a data url string
     * @param stringToParse The data url that this object shall be created from
     */
    static fromString = function (stringToParse) {
        var isBase64 = false;
        var mimeType;
        var data;
        if (stringToParse != null || this.isDataURI(stringToParse.toString())) {
            // see https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs#Syntax
            // todo: since the url is now validated
            var _splitAtComma = stringToParse.split(',');
            // if no comma was found, the string is not valid
            if (_splitAtComma === null) {
                throw new Error('data url string is not valid');
            }
            else {
                data = _splitAtComma[1];
                var _splitAtColon = _splitAtComma[0].split(':');
                // if no colon was found, the string is not valid
                if (_splitAtColon === null) {
                    throw new Error('data url string is not valid');
                }
                else {
                    var _trimmed = _splitAtColon[1].trim();
                    if (_trimmed !== '') {
                        // if there is additional data
                        var _splitAtSemicolon = _trimmed.split(';');
                        // if semicolon was found, check if it states 'base64'
                        if (_splitAtSemicolon !== null) {
                            // if it states something else, string is not valid
                            if (_splitAtSemicolon[1] !== 'base64') {
                                throw new Error('data url string is not valid');
                            }
                            else {
                                isBase64 = true;
                            }
                            // if there was a semicolon, look to the left of it to find the MIME type, if there is anything
                            var _mimeType = _splitAtSemicolon[0];
                            if (_mimeType !== null && _mimeType.trim() !== '') {
                                if (!MimeType.isValid(_mimeType)) {
                                    throw new Error('data url string is not valid');
                                }
                                mimeType = new MimeType(_mimeType);
                            }
                        }
                        else {
                            // if no semicolon was found but there is additional data, then it must be the MIME type
                            if (!MimeType.isValid(_trimmed)) {
                                throw new Error('data url string is not valid');
                            }
                            mimeType = new MimeType(_trimmed);
                        }
                    }
                }
            }
            return new DataUrl(mimeType, data, isBase64);
        }
    };

}
    

export class MimeType{
    /**
     * @param toParse a MIME string to parse into an object
     * @param options Some further options
     */
    private _type : any;
    private _subtype : any;
    private _isCustomType : any;

    constructor(toParse, options?) {
        // apply default options
        options = Object.assign(defaultMimeTypeOptions, options);

        // if it is not a custom type, check if the db query returns empty or the result has an empty source
        if (!options.customType && (!_MimeDB[toParse] || !_MimeDB[toParse].source)) {
            throw new Error("'" + toParse + " can't be parsed to a MimeType");
        }
        // we can now expect the string to be valid
        var _split = toParse.split('/');
        // since we can expect the overall string to be valid, we can expect the shift to be defined
        this._type = _split.shift();
        this._subtype = _split.shift();
        this._isCustomType = options.customType;
    }
    /**
     * Create a MIME type from a file name
     * @param fileName The name of the file
     * @param options Some further options
     */
     static fromFileName = function (fileName, options) {
        var _split = fileName.split('.');
        if (_split && _split.length > 1) {
            // the extension is expected to be at the end, so we take the last element of the array
            return MimeType.fromFileExtension(_split.pop(), options);
        }
        else {
            throw new Error("'" + fileName + "' is not a valid file name with an extension");
        }
    };
    /**
     * Create a MIME type from a file extension
     * @param fileExtension The file extension
     * @param options Some further options
     */
    static fromFileExtension = function (fileExtension, options?) {
        var _mimeString = this.fromFileExtensionToString(fileExtension);
        if (_mimeString) {
            return new MimeType(_mimeString, options);
        }
        else {
            throw new Error(fileExtension + " is not a known extension for a MIME type");
        }
    };
    /**
     * Directly from a file extension to a string
     * @param extension The file extension
     */
    static fromFileExtensionToString = function (extension) {
        for (var mime in _MimeDB) {
            // the following 'error' can be ignored because _MimeDB[mime].extensions is checked for definedness
            // /@ts-ignore
            if (_MimeDB.hasOwnProperty(mime) && _MimeDB[mime].extensions && _MimeDB[mime].extensions.includes(extension)) {
                return mime;
            }
        }
        // if the function has not returned by now, then we can assume that the extension is not known
        throw new Error(extension + " is not a known extension for a MIME type");
    };
    /**
     * Check if the string is a valid MIME type string
     * @param string The string to be checked
     */
   static isValid = function (string) {
        return !!_MimeDB[string];
    };
    /**
     * Get the type of the MIME type
     */
    getType = function () {
        return this._type;
    };
    /**
     * Get the subtype of the MIME type
     */
    getSubtype = function () {
        return this._subtype;
    };
    /**
     * Serialize the MIME type to string
     */
    toString = function () {
        return this._type + "/" + this._subtype;
    };

}
var defaultMimeTypeOptions = {
    /**
     * By default, only accept offical types
     */
    customType: false
};


export class Utils {
    static binaryImageDataToDataUrl = function (imageData: Uint8ClampedArray, width: number, height: number, format?: 'RGBA' | 'RGB' | 'AUTODETECT') {
        if (format === void 0) { format = 'AUTODETECT'; }
        var _canvas = document.createElement('canvas');
        var _ctx = _canvas.getContext('2d');
        _canvas.width = width;
        _canvas.height = height;
        _ctx.putImageData(Utils.binaryToImageData(imageData, width, height, format), 0, 0);
        var dataUrl = DataUrl.fromString(_canvas.toDataURL('image/png'));
        // clear the canvas such that it won't occupy unnecessary memory until the next garbage collector cycle
        _ctx.clearRect(0, 0, 0, 0);
        return dataUrl;
    };

    static binaryToImageData = function (imageData : Uint8ClampedArray, width: number, height: number, format?: 'RGBA' | 'RGB' | 'AUTODETECT') {
        if (format === void 0) { format = 'AUTODETECT'; }
        var _imageData = new ImageData(width, height);
        if (
        // check if RGBA is provided or it should be autodetected
        format === 'RGBA' ||
            (format === 'AUTODETECT' && imageData.length % (width * 4) === 0 && imageData.length % (width * height * 4) === 0)) {
            var UAC = new Uint8ClampedArray(imageData, width, height);
            _imageData = new ImageData(UAC, width, height);
        }
        else if (
        // just double check
        format === 'RGB' ||
            (format === 'AUTODETECT' && (imageData.length % (width * 3) === 0 || imageData.length % (width * height * 3) === 0))) {
            // if we got here, it means that at least one of the requirements was violated and padding was wished.
            if (width * height * 4 > imageData.length) {
                var newImageData = _imageData; // _ctx.createImageData(width, height);
                var indexNewImageData = 0;
                var indexOldImageData = 0;
                while (indexOldImageData < imageData.length) {
                    newImageData.data[indexNewImageData] = imageData[indexOldImageData];
                    newImageData.data[indexNewImageData + 1] = imageData[indexOldImageData + 1];
                    newImageData.data[indexNewImageData + 2] = imageData[indexOldImageData + 2];
                    newImageData.data[indexNewImageData + 3] = 255;
                    // Even though I can't find a hint when inspecting the PDF's object tree, it seems that in this case the data provided is
                    // only in RGB and not in RGBA, thus we need to 'stuff in' the alpha value
                    indexNewImageData += 4;
                    indexOldImageData += 3;
                }
            }
        }
        else {
            // The image data was not understood
            throw new Error('The binary image data was not understood as RGBA nor as RGB.');
        }
        return _imageData;
    };

    static readBlobAsDataUrl = function (blob : Blob) {
        return new Promise<DataUrl>(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function (e) {
                resolve(DataUrl.fromString(reader.result.toString()));
            };
            reader.onerror = function (e) {
                reject(reader.error);
            };
            reader.readAsDataURL(blob);
        });
    };

    static areSimilarArrays = function (array1, array2) {
        var moreArrays = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            moreArrays[_i - 2] = arguments[_i];
        }
        // first check if the length is the same
        if (array1.length !== array2.length) {
            // if the lengths of the first two array already don't match, return false
            return false;
        }
        else {
            if (moreArrays) {
                // if there are more array, test each's length against the first array's length
                for (var _a = 0, moreArrays_1 = moreArrays; _a < moreArrays_1.length; _a++) {
                    var anotherArray = moreArrays_1[_a];
                    if (anotherArray.length !== array1.length) {
                        // if any of the arrays has a different length, return false
                        return false;
                    }
                }
            }
            // that we've checked that all passed array are of identical length, let's check the values
            for (var i = 0; i < array1.length; i++) {
                if (array1[i] !== array2[i]) {
                    return false;
                }
                if (moreArrays) {
                    for (var _b = 0, moreArrays_2 = moreArrays; _b < moreArrays_2.length; _b++) {
                        var anotherArray = moreArrays_2[_b];
                        if (anotherArray[i] !== array1[i]) {
                            return false;
                        }
                    }
                }
            }
            // now we've checked all the values and the function has not returned yet.
            // Thus, the given array all must be similar
            return true;
        }
    };

    static readFileAsDataUrl = function (file) {
        return Utils.readBlobAsDataUrl(file);
    };

    static safeUnsubscribe = function (subscriptions: any[]) {
        for (var _a = 0, subscriptions_1 = subscriptions; _a < subscriptions_1.length; _a++) {
            var subscription = subscriptions_1[_a];
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    };

    static saveAs = function (data, filename, options?) {
        return FileSaver.saveAs(data, filename, options);
    };
}

var validator = require("validator");

export class UUID {
    /**
     * The uuid as string
     */
    private readonly _asString;
    /**
     * @param uuid The uuid to parse from
     */
    constructor(uuid: string){
        if (validator.default.isUUID(uuid)) {
            this._asString = uuid;
        }
        else {
            // try to add the dashes at the correct position and validate again
            if (uuid.length != 32) {
                this.throwErrorNotValidUuid(uuid);
            }
            else {
                var insertDash = function (position) {
                    uuid = uuid.slice(0, position - 1) + '-' + uuid.slice(position - 1);
                };
                insertDash(9);
                insertDash(14);
                insertDash(19);
                insertDash(24);
                // now, after inserting the dashes, test it again
                if (validator.default.isUUID(uuid)) {
                    this._asString = uuid;
                }
                else {
                    this.throwErrorNotValidUuid(uuid);
                }
            }
        }
    }
    private throwErrorNotValidUuid = function (uuid) {
        throw new Error(uuid + " is not a valid UUID");
    };
    /**
     * Serialize to string
     */
    toString = function () {
        if (this._asString)
            return this._asString;
        else
            return '';
    };
    /**
     * Check if a string is a valid UUID/GUID
     * @param uuid The UUID/GUID to check
     */
    static isUUID = function (uuid) {
        return validator.default.isUUID(uuid);
    };
}


var ObjectHash = require("object-hash");
export type MD5 = string;
export class Crypto{
    static md5 = function (value) : MD5{
        var objectHash = ObjectHash;
        return objectHash.MD5(value);
    };
    
}